import { useState } from 'react';
import { supabase } from './supabaseClient';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSignIn(e) {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Optional: enforce @dataneers.in
    if (!email.endsWith('@dataneers.in')) {
      setError('Only @dataneers.in accounts are permitted.');
      setLoading(false);
      return;
    }

    console.log('Attempting sign in with email:', email);
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      console.error('Sign in error:', error);
      setError(error.message);
    } else {
      console.log('Sign in successful, session should update via listener');
    }
    setLoading(false);
  }

  async function handleSignUp(e) {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!email.endsWith('@dataneers.in')) {
      setError('Only @dataneers.in accounts can sign up.');
      setLoading(false);
      return;
    }

    console.log('Attempting sign up with email:', email);
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: window.location.origin, // redirect after confirmation
      },
    });

    if (error) {
      console.error('Sign up error:', error);
      setError(error.message);
    } else {
      console.log('Sign up successful! Check email for confirmation.');
      alert('Account created! Please check your email for confirmation (if enabled).');
    }
    setLoading(false);
  }

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.logo}>Dataneers</div>
        <div style={styles.title}>Sales rep portal</div>
        <div style={styles.sub}>Sign in with your Dataneers email</div>

        <form onSubmit={handleSignIn}>
          <input
            type="email"
            placeholder="Email (@dataneers.in)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            required
          />
          <button type="submit" style={styles.btn} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <div style={styles.signupRow}>
          <span style={styles.note}>New rep?</span>
          <button onClick={handleSignUp} style={styles.linkBtn} disabled={loading}>
            Create account
          </button>
        </div>

        {error && <div style={styles.error}>{error}</div>}
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: '#F8F9FA', padding: 16,
  },
  card: {
    background: '#fff', borderRadius: 16, border: '0.5px solid #E5E7EB',
    padding: '40px 36px', maxWidth: 360, width: '100%', textAlign: 'center',
  },
  logo: {
    fontSize: 13, fontWeight: 500, color: '#1B3A5C',
    letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 20,
  },
  title: { fontSize: 22, fontWeight: 500, color: '#111827', marginBottom: 8 },
  sub: { fontSize: 14, color: '#6B7280', marginBottom: 28, lineHeight: 1.5 },
  input: {
    width: '100%', padding: '10px 12px', marginBottom: 12,
    borderRadius: 8, border: '0.5px solid #D1D5DB', fontSize: 14,
    boxSizing: 'border-box',
  },
  btn: {
    width: '100%', padding: '11px 16px', borderRadius: 10,
    border: 'none', background: '#1B3A5C', color: '#fff', cursor: 'pointer',
    fontSize: 14, fontWeight: 500, marginBottom: 16,
  },
  signupRow: { display: 'flex', justifyContent: 'center', gap: 8, fontSize: 13 },
  linkBtn: { background: 'none', border: 'none', color: '#1B3A5C', cursor: 'pointer', fontWeight: 500 },
  note: { color: '#6B7280' },
  error: { marginTop: 16, fontSize: 13, color: '#A32D2D' },
};